import { render, staticRenderFns } from "./trendssc.vue?vue&type=template&id=e267b87a"
import script from "./trendssc.vue?vue&type=script&lang=js"
export * from "./trendssc.vue?vue&type=script&lang=js"
import style0 from "./trendssc.vue?vue&type=style&index=0&id=e267b87a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports